@let height = slotHeight;
<div id="shive-timegrid-body" class="day-view {{ zoomFactorCSSClass }}">
  <div id="shive-timegrid-slots">
    <table>
      <colgroup>
        <col class="fixed-lane" />
      </colgroup>
      <tbody>
        @for (hour of hourLabels; track hour) {
          <tr>
            <td
              class="shive-timegrid-slot shive-timegrid-slots-label fixed-col"
              [style.height.px]="height"
            >
              <div class="shive-timegrid-slot-label-frame">
                <div class="shive-timegrid-slot-label-cushion">
                  {{ hour | date: calService.model.calendarProperties.timeFormat }}
                </div>
              </div>
            </td>
            <td
              class="shive-timegrid-slot shive-timegrid-slot-lane"
              [style.height.px]="height"
            ></td>
          </tr>
          <tr>
            <td
              [style.height.px]="height"
              class="shive-timegrid-slot shive-timegrid-slots-label shive-timegrid-slot-minor fixed-col"
            ></td>
            <td
              [style.height.px]="height"
              class="shive-timegrid-slot shive-timegrid-slot-lane shive-timegrid-slot-minor"
            ></td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <div id="shive-timegrid-lanes">
    <table>
      <colgroup>
        <col class="fixed-lane" />
      </colgroup>
      <tbody>
        <tr>
          <td class="fixed-col"></td>
          <td>
            <table class="item-container" #itemContainer>
              <tr>
                @for (day of days; track day) {
                  <td class="weekday lane" [class]="day.epoch" #lane>
                    @if (day.epoch === "today") {
                      <div id="now-indicator" appNowIndicator></div>
                    }
                    <ng-container appTimeBlockContainer></ng-container>
                  </td>
                }
              </tr>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
